import { Box, Loader } from '@mantine/core';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/authContext';
import { PageRoutes } from '../routes';

export function AuthenticatedBoundary({ children }: { children: React.ReactNode }) {
  const { user, initialAuthChecked } = useContext(AuthContext);

  if (!initialAuthChecked) {
    return (
      <Box mih='70vh' style={{ display: 'grid', placeItems: 'center' }}>
        <Loader aria-label='Restoring your session' />
      </Box>
    );
  }
  if (!user || user.isAnonymous) return <Navigate to={PageRoutes.LOGIN} replace />;
  return <>{children}</>;
}
